import { useSyncExternalStore } from 'react';
import type { Theme } from '../core/theme/theme';
import { getServerTheme, getTheme, setTheme, subscribeToTheme } from './theme-store';

/**
 * The appearance the site is being read in, and the one way to change it.
 *
 * **The state is the class on `<html>`** — read through the store rather than held here — so the
 * button cannot open describing an appearance the visitor is not in, and two switches on the same
 * page cannot disagree.
 *
 * **It has a server snapshot because the content pages are rendered at build time.** There is no
 * document to read a class from and no visitor whose choice could be known, so the prerendered
 * markup carries the light switch and React settles it after hydration. Reading the real class
 * during hydration instead would replace the whole page for every visitor who chose dark.
 *
 * There is no context and no provider: the class lives on `<html>` and every `dark:` rule in the
 * application reads it from there through the cascade, so a second component that wants to render a
 * switch needs this hook and nothing else.
 */
export function useTheme(): { theme: Theme; setTheme: (theme: Theme) => void } {
    const theme = useSyncExternalStore(subscribeToTheme, getTheme, getServerTheme);

    return { theme, setTheme };
}
